const defaultApiBaseUrl = 'https://surveyslack.com/surveyslack-apis/APIs';
const configuredApiBaseUrl = defaultApiBaseUrl;
const API_CONFIG = {
    BASE_URL: configuredApiBaseUrl.replace(/\/+$/, ''),
    ENDPOINTS: {
        SURVEYS: {
            CREATE: '/create_survey.php',
            CREATE_FROM_TEMPLATE: '/create_survey_from_template.php',
            LIST: '/list_surveys.php',
            GET: '/get_survey.php',
            UPDATE: '/update_survey.php',
            DELETE: '/delete_survey.php',
            GET_PUBLIC: '/get_public_survey.php',
            GET_ANALYTICS: '/get_survey_analytics.php',
            GET_RESPONSES: '/get_all_survey_responses.php',
            GET_QUESTION_PROGRESS: '/get_question_progress.php', 
            DELETE_RESPONSE: '/delete_response.php',
           DELETE_ALL_RESPONSES: '/delete_all_Pending_responses.php',
           GET_DOC_FILE: '/get_file.php',
           UPLOAD_FILE: '/upload_doc.php',
        },
        TEMPLATES: {
            LIST: '/list_templates.php',
            GET: '/get_template.php'
        },        QUESTIONS: {
            CREATE: '/create_question.php',
            LIST: '/list_questions.php',
            UPDATE: '/update_question.php',
            DELETE: '/delete_question.php',
            BULK_UPDATE: '/bulk_update_questions.php',
            UPDATE_POSITIONS: '/update_question_positions.php'
        },
        LOGIC_RULES: {
            LIST: '/logic_rules.php',
            CREATE: '/logic_rules.php',
            UPDATE: '/logic_rules.php',
            DELETE: '/logic_rules.php',
            TOGGLE: '/logic_rules.php',
            VALIDATE: '/validate_logic.php'
        },
        RESPONSES: {
            SUBMIT: '/submit_response.php',
            LIST: '/list_responses.php',
            SAVE_RESPONDER: '/APIs/save_response.php',
             INITIALIZE_RESPONDER: '/initialize_responder.php'
            
        },
        ONBOARDINGRESPONSES: {
           SUBMIT: '/save_onboarding.php', 
        },
        STRIPE: {
          CREATE: '/checkout/create-session.php',  // Updated path
          VERIFY_SESSION: '/checkout/verify-session.php', 
          WEBHOOK: '/checkout/webhook-handler.php',
           CREATE_PORTAL: '/checkout/create-portal-session.php'
        },AUTH: {
            SAVE_USER: '/save_user.php',
            CHECK_USER_ONBOARDING: '/check-user-onboarding.php'
        },
        USER: {
            // CHECK_SUBSCRIPTION: '/checkout/check_subscription_status.php',
            CHECK_SUBSCRIPTION: '/check_subscription.php',
            START_TRIAL: '/save_trial_subscription.php',
            LIST_USERS_WITH_ONBOARDING: '/list_users_with_onboarding.php'
        },
        SUPPORT: {
            REPORT_BUG: '/report_bug.php'
        },
        EMAIL: {
            GET_PREFERENCES: '/get_email_preferences.php',
            UPDATE_PREFERENCES: '/update_email_preferences.php',
            UNSUBSCRIBE: '/unsubscribe.php'
        },
        ADMIN: {
            SURVEYS: '/admin/surveys.php',
            EMAILS: '/admin/emails.php',
            EMAIL_STATS: '/admin/email-stats.php',
            PROCESS_EMAIL_QUEUE: '/admin/process-email-queue.php',
            CANCEL_EMAIL: '/admin/cancel-email.php'
        }
    }
};

export const getApiUrl = (endpoint) => `${API_CONFIG.BASE_URL}${endpoint}`;
console.log('APi base url:', API_CONFIG.BASE_URL);
export default API_CONFIG;